<template>
  <div class="placeholder" @click="openUploader">
    <img :src="placeholderImage" alt="Plus" />
    <span>{{ placeholderText }}</span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { i18n } from "../../../i18n";

export default {
  props: {
    text: {
      type: String,
      default: () => null,
    },
    uploaderId: {
      type: String,
      default: () => "originalFile",
    },
  },
  computed: {
    ...mapGetters("product", {
      product: "getProduct",
    }),
    placeholderText() {
      return this.text || this.t("Upload file");
    },
    placeholderImage() {
      return (
        `/img/icons/plus/plus-${this.product.category_id}.svg` ||
        "/img/icons/plus/plus.svg"
      );
    },
  },
  methods: {
    openUploader() {
      $(`input#${this.uploaderId}`).trigger("click");
    },
  },
  setup() {
    const { t } = i18n.global;

    return {
      t,
    };
  },
};
</script>
